import type { ApiUser } from '../../types/users';
import type { OpenImRawUser } from './types';

// Mirrors the JSON tags on `model_struct.LocalFriend`/`model_struct.LocalUser`/
// `model_struct.LocalGroupMember` (openim-sdk-core `pkg/db/model_struct/data_model_struct.go`) —
// all three structs use the exact same `userID`/`nickname`/`faceURL` field names, so this single
// mapper is reused for a friend entry (`getFriendListPage`), the logged-in user's own record
// (`getSelfUserInfo`), and a group member (`getGroupMemberList`, via `methods/groups.ts`) alike.
// `isContact` defaults to `true` (friend/self callers never pass it) but a group member isn't
// necessarily a friend, so `methods/groups.ts` explicitly passes `false` there -- getting this wrong
// would wrongly add/remove a real contact from the contact list via `updateContactList` the moment
// they're also seen as a group member.
export function mapOpenImUserToApiUser(raw: OpenImRawUser, isContact = true): ApiUser {
  return {
    id: raw.userID,
    isMin: false,
    // `ApiUser.isContact` is typed `true | undefined` (never a bare `false`) -- see
    // `src/api/types/users.ts` -- so a non-contact must omit the field, not set it `false`.
    isContact: isContact ? true : undefined,
    type: 'userTypeRegular',
    firstName: raw.nickname || raw.userID,
    phoneNumber: '',
    noStatus: true,
    avatarBlobUrl: raw.faceURL || undefined,
  };
}
